import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoadingService {
  private _count = 0;
  private _visible$ = new BehaviorSubject<boolean>(false);

  get visible$() {
    return this._visible$.asObservable();
  }

  show() {
    this._count++;
    if (this._count > 0) {
      this._visible$.next(true);
    }
  }

  hide() {
    this._count = Math.max(0, this._count - 1);
    if (this._count === 0) {
      this._visible$.next(false);
    }
  }

  reset() {
    this._count = 0;
    this._visible$.next(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/loading.service.ts